import { styled } from '@mui/material'

export const ContentContainer = styled('div')`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
`

export const IconWrapper = styled('div')`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.palette.error100};
  display: flex;
  align-items: center;
  justify-content: center;
`

export const TextWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`
